import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useParams } from 'react-router-dom';
import '../Assets/CSS/EventPage.css';
import { getCookie } from '../components/auth/login/GetCookie';
// import { set } from 'react-hook-form';

const EventDetailpage = () => {
      // Helper function to get cookie value
    const [eventList, setEventList] = useState([]);
    const [loading,setLoading]=useState();
    const [eventDetail, setEventDetail] = useState([]);
    const { eventId } = useParams();
    console.log(eventId)


    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
        fetchEvents();
    }, [eventId]);
    const fetchEvents = async () => {
        setLoading(true);
        try {
             await new Promise(res => setTimeout(res, 2000)); // simulate delay
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/event/allevents`,
            );
            const data = await response.json();
            setEventList(data);
            console.log(eventList);
        }
        catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
        finally{
            setLoading(false);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        //const token = localStorage.getItem('token'); // Retrieve the token from localStorage or any other storage
          const token = getCookie("token");
        try {
            //  await new Promise(res => setTimeout(res, 2000)); // simulate delay
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/event/${eventId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Include the Bearer token
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            setEventDetail(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally{
            setLoading(false)
        }
    };


    const renderSkeleton = () => (
        <div className="container my-5">
            <div className="skeleton-loader rounded mb-4" style={{ width: '100%', height: '400px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '60%', height: '25px', backgroundColor: '#ddd' }} />
            <div className="skeleton-loader mb-2" style={{ width: '80%', height: '20px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '90%', height: '20px', backgroundColor: '#eee' }} />
            <div className="skeleton-loader mb-2" style={{ width: '85%', height: '20px', backgroundColor: '#eee' }} />
        </div>
    );

    if (!eventList) {
        return <p>Event not found</p>;
    }

    return (
        <div className='common-margin' >
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12 bannerimgEvent pb-4'>
                    <h1 className='blog-heading p-2 mt-3'>
                        <Link to='/' className='text-white text-decoration-none'>
                            <Icon icon="iconamoon:home-thin" className='fs-4 pb-1 me-1' />
                        </Link>
                        <Link to='/events' className='text-white text-decoration-none'>
                            <Icon icon="weui:arrow-outlined" className='fs-3 pb-1  me-1' />
                            <span className='fs-6 me-1'>Events</span>
                        </Link>
                        <Icon icon="weui:arrow-outlined" className='fs-3 pb-1 me-1' />
                        {eventDetail.eventTitle}
                    </h1>
                    <h2 className='Event-headingtwo'>{eventDetail.eventTitle}</h2>
                    <div className='row ms-3'>
                        <div className='col-lg-3 col-md-4 col-sm-12 d-flex justify-content-between align-items-center'>
                            <p className='eventer-name mb-0 text-start'>{eventDetail.createdBy}</p>
                            <p className='event-Detail-date mb-0 text-end'>{new Date(eventDetail.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</p>

                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
            {loading || !eventList ? (
                    renderSkeleton()
                ) : (
                    <>
                <div className='blog-detail'>
                    <div className='row mt-5'>
                        {/* Main Blog Item */}
                        <div className='col-12 mb-4'>
                            <img
                                src={eventDetail.eventImage}
                                alt='event'
                                className=' rounded-3'
                                style={{
                                    width:'800px',
                                    height: '450px'
                                }}
                            />
                            <h6 className='blog-span text-center mt-3'>{eventDetail.eventTitle}</h6>
                            <p className='blog-para mt-4 mb-5 text-left'>
                                {eventDetail.eventDescription}
                            </p>
                        </div>
                    </div>
                </div>
                </>
                )}
                <div className='other-blog'>
                    <h1 className='other-blog-heading' style={{ color: '#303030' }}>Other Events:</h1>
                    <div className='row'>
                    {loading
            ? [...Array(3)].map((_, index) => (
                <div key={index} className='col-lg-4 col-md-12 col-sm-12 mb-5'>
                    <div className='blogCard skeleton-card p-3'>
                        <div
                            className='skeleton skeleton-img rounded-4 mb-3'
                            style={{ width: '100%', height: '250px' }}
                        />
                        <div className='skeleton skeleton-text w-75 mb-2' style={{ height: '20px' }} />
                        <div className='skeleton skeleton-text w-100 mb-2' style={{ height: '16px' }} />
                        <div className='skeleton skeleton-text w-50' style={{ height: '14px' }} />
                    </div>
                </div>
            )):
                        eventList
                            .filter((otherEvent) => otherEvent.eventId != eventId) // Filter out the blog matching blogId
                            .slice(0, 3) // Take the first three after filtering
                            .map((otherEvent) => (
                                <div key={otherEvent.eventId} className='col-lg-4 col-md-12 col-sm-12'>
                                    <Link to={`/events/eventdetail/${otherEvent.eventId}`} className="text-decoration-none text-dark">
                                        <div className='blogCard mb-5'>
                                            <img
                                                src={otherEvent.eventImage[0]}
                                                alt={`event${otherEvent.eventId}`}
                                                className='img-fluid overflow-hidden rounded-4'
                                                style={{ height: '250px', width: '450px' }}
                                            />
                                            <h5 className='card-title pt-2'>{otherEvent.eventTitle}</h5>
                                            <p className='card-text pt-2'>{otherEvent.eventDescription.slice(0, 80)}<span>...</span></p>
                                            <small className="text-muted">{new Date(otherEvent.createdAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</small>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}

export default EventDetailpage;
